import React from 'react'
import Element from './Element'
import {PageProvider} from '../PocketHitsShared/page-context';
import { state } from '../PocketHitsShared/state';

const { newsletterPage } = state

export default () => (
    <PageProvider {...newsletterPage}>
      <Element initialSignedParams={null} />
    </PageProvider>
)
